import { useCurrentAuthenticatedUser } from '#src/app/shared/hooks/session';

type Country = Readonly<{ countryCode: string; displayName: string }>;

type Result = ModelHookResult<{
	countries: readonly Country[];
	initialValue: string | undefined;
}>;

export function useCountryField(countries: readonly Country[]): Result {
	const userCountryCode = useCurrentAuthenticatedUser()?.country?.countryCode;

	return {
		data: {
			countries,
			initialValue: userCountryCode,
		},
	};
}
